import { get } from '../utils/axios'

export const getTitlesAPI = async () => {
  return await get('titles')
}
